import React, { useState } from 'react';
import { Fade, ImageListItem, ImageListItemBar, IconButton } from '@mui/material';
import imageStatusIconEnum from '../../../enums/imageStatusIconEnum';
import VisibilitySensor from 'react-visibility-sensor';
import { showOverlay } from '../../../utils/showOverlay';
import { getDateTimeFromMillisecondsTZ } from '../../../utils/getDateFormat';
import { useSelector } from 'react-redux';
import { handle_image } from '../../../store/services/image-management/handle-image';
import { useAppDispatch } from '../../../store/configureStore';
import remove_duplicates_from_list from '../../../utils/remove_duplicates_from_list';

export default function ImageItem({ imageItem }) {
  const dispatch = useAppDispatch();
  const [isVisible, setVisibility] = useState(false);
  const { selectedImageIds, temporaryImageIds } = useSelector((state) => state.images);
  let temp_ids = temporaryImageIds || [];
  let selected_ids = selectedImageIds || [];
  let list = [...selected_ids, ...temp_ids];

  list = remove_duplicates_from_list(list);
  const index = list.findIndex((id) => id === imageItem.image_id);

  return (
    <VisibilitySensor
      partialVisibility
      onChange={(visibilityState) => {
        if (!isVisible && visibilityState) {
          setVisibility(visibilityState);
          showOverlay(true);
        }
      }}
    >
      <Fade in={isVisible} timeout={1000}>
        <ImageListItem
          style={image}
          sx={index !== -1 ? selected : unselected}
          onClick={() => dispatch(handle_image(imageItem?.image_id))}
        >
          <img src={isVisible ? imageItem.s3_keys.preview : ''} loading="lazy" />
          <ImageListItemBar
            title={imageItem?.sort_info?.origin_path}
            subtitle={getDateTimeFromMillisecondsTZ(
              imageItem?.sort_info?.date_taken,
              imageItem?.sort_info?.user_timezone,
            )}
            actionIcon={
              <IconButton aria-label={`info about ${imageItem?.sort_info?.origin_path}`}>
                <img src={imageStatusIconEnum[imageItem?.status?.status]} />
              </IconButton>
            }
          />
        </ImageListItem>
      </Fade>
    </VisibilitySensor>
  );
}

const image = {
  width: '100%',
  height: 'auto',
  cursor: 'pointer',
};

const selected = {
  border: 2,
  borderColor: 'primary.main',
};

const unselected = {
  border: 2,
  borderColor: 'transparent',
};
